import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
//import { withTranslation } from "react-i18next"
import { withRouter } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addTabEmail, getTabEmail } from "../../../store/actions"
import Moment from 'react-moment';
import { isEmpty, map } from "lodash";
import {
  Row,
  Col,
  FormGroup,
  Label
} from "reactstrap"
import classnames from "classnames"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { withTranslation } from "react-i18next";
import SaveButton from "components/buttons/save";
import SafeField from "helpers/SafeField";
class EmailLog extends Component {
  constructor(props) {
    super(props)
    this.state = {


    }
    this.handSubmit = this.handSubmit.bind(this)
  }
  handSubmit(value) {
    this.props.addTabEmail(value, this.props.history)
  }
  componentDidMount() {
    const { match: { params }, onGetTabEmail } = this.props;
    onGetTabEmail(params.id);
  }
  render() {
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { emailLogs, contactDetail } = this.props;
    return (
      <React.Fragment>

        <Formik
          enableReinitialize={true}
          initialValues={{
            remarks: (this.state && this.state.remarks) || "",
            actionType: 'Email Sent',
            addedDate: new Date(),
            refId: contactDetail?.id,
            addedBy: parseInt(localStorage.getItem('userId')),

          }}
          validationSchema={Yup.object().shape({
            actionType: Yup.string().required(
              "Please Select Action"
            ),
            //remarks: Yup.string().max(500, 'This filed contains only 500 characters only').required("This is Required")
          })}

          onSubmit={this.handSubmit}
        >
          {({ errors, touched, values, handleChange, setFieldValue }) => (
            <Form
              className="needs-validation"
            >

              <Row className="mb20">



                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="builderName">
                      {this.props.t("Select Type")}
                    </Label>
                    <div className="clearfix"></div>
                    <div className="btn-group" role="group">
                      <SafeField type="radio" className="btn-check"
                        name="actionType" id="actionType_e_1"
                        value='Email Sent'
                        checked={values.actionType === 'Email Sent'}
                        onChange={() => {
                          setFieldValue("actionType", 'Email Sent')

                        }}
                        autoComplete="off" />
                      <label className="btn btn-outline-secondary" htmlFor="actionType_e_1">Email Sent</label>

                      <SafeField type="radio" className="btn-check" name="actionType" id="actionType_e_2" value='Email Received'
                        checked={values.actionType === 'Email Received'}

                        onChange={() => {
                          setFieldValue("actionType", 'Email Received')

                        }}

                        autoComplete="off" />
                      <label className="btn btn-outline-secondary" htmlFor="actionType_e_2">Email Received</label>

                      <SafeField type="radio" className="btn-check" name="actionType" id="actionType_e_3"
                        value={4}
                        checked={values.actionType === 'Email Bounced'}

                        onChange={() => {

                          setFieldValue("actionType", "Email Bounced")
                        }}
                        autoComplete="off" />
                      <label className="btn btn-outline-secondary" htmlFor="actionType_e_3">Email Bounced</label>


                    </div>
                    <ErrorMessage
                      name="activityType"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="emailNote">
                      {this.props.t("Log Date")}
                    </Label>
                    <Flatpickr
                      className={
                        "form-control" +
                        (errors.addedDate && touched.addedDate
                          ? " is-invalid"
                          : "")
                      }
                      placeholder=""
                      value={values.addedDate}
                      onChange={(value) => setFieldValue('addedDate', value[0])}
                      options={{
                        altInput: true,
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d"
                      }}
                    />
                    <ErrorMessage
                      name="addedDate"
                      component="div"
                      className="invalid-feedback"
                    />

                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="remarks">
                      {this.props.t("Add Message")}
                    </Label>
                    <textarea
                      name="remarks"
                      onChange={(e) => setFieldValue("remarks", e.target.value)}
                      type="textarea"
                      value={values.remarks}
                      className="form-control"

                      id="remarks"

                    />
                    <ErrorMessage
                      name="remarks"
                      component="div"
                      className="text-danger"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="clearfix"><SaveButton>Save</SaveButton></div>


            </Form>
          )}
        </Formik>
        {emailLogs && emailLogs.length > 0 ? (
          <>
            <div className="h4 card-title mt-20">Email Log History</div>
            <ul className="verti-timeline list-unstyled">

              {map(emailLogs, (emailLog, emailkey) => (

                <li className="event-list eventlist" key={"_email_" + emailkey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                    </div>
                  </div>
                  <div className="exNote">{emailLog.activityRemarks}</div>
                </li>
              ))}

            </ul>
          </>
        ) : null}
      </React.Fragment>
    )
  }
}
EmailLog.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
  match: PropTypes.object,
  emailLogs: PropTypes.array,
  addTabEmail: PropTypes.func,
  onGetTabEmail: PropTypes.func,
  contactDetail: PropTypes.object
}
const mapStateToProps = ({ contact }) => (
  {
    emailLogs: contact.emailLogs,
  })
const mapDispatchToProps = dispatch => ({

  addTabEmail: (data) => dispatch(addTabEmail(data)),
  onGetTabEmail: (leadId) => dispatch(getTabEmail(leadId)),

});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmailLog)))

